import "./dragula.min.css";
import dragula from "../../_rc-react-dragula";
import isFunction from "lodash/isFunction";
import findIndex from "lodash/findIndex";
import middleware from "../../middleware";

class WeaDragula extends React.Component {
  constructor(props) {
    super(props);
    this.drake = null;
    this.state = {
      // tableEdit 多页情况下拖拽效果不对
      page: props.page,
      pageSize: props.pageSize
    };
  }
  componentDidMount() {
    if (!this.drake) this.initDragula();
  }

  componentWillReceiveProps(nextProps) {
    const { page: nextPage, pageSize: nextPageSize } = nextProps;
    const { page, pageSize } = this.state;
    if (
      nextPage &&
      nextPageSize &&
      (page !== nextPage || pageSize !== nextPageSize)
    ) {
      this.setState({ page: nextPage, pageSize: nextPageSize });
    }
  }

  componentDidUpdate() {
    if (!this.drake) this.initDragula();
  }

  componentWillUnmount() {
    this.drake && this.drake.destroy();
  }

  render() {
    return this.props.children;
  }

  initDragula = () => {
    let {
      container,
      canDrag,
      direction,
      onDrop,
      getKeyFromDom,
      getKeyFromData
    } = this.props;
    if (typeof container == "string") {
      container = jQuery(container, ReactDOM.findDOMNode(this))[0];
    } else if (isFunction(container)) {
      container = container();
    }
    const containerDocument = container ? container.ownerDocument : document;
    if (!container) {
      this.dragulaTimeout = setTimeout(() => {
        if (!this.drake) this.initDragula();
      }, 500);
      return;
    }
    if (this.dragulaTimeout) {
      clearTimeout(this.dragulaTimeout);
    }
    this.drake = dragula([container], {
      isContainer: function(el) {
        return false;
      },
      moves: (el, source, handle, sibling) => {
        return isFunction(canDrag)
          ? canDrag(handle, el, source, sibling)
          : canDrag;
      },
      mirrorContainer: container,
      direction: direction,
      // doc: document,
      doc: containerDocument
    });

    this.drake.on("drop", (el, target, source, sibling) => {
      let { datas } = this.props;
      if (
        Array.isArray(datas) &&
        isFunction(getKeyFromDom) &&
        isFunction(getKeyFromData) &&
        isFunction(onDrop)
      ) {
        let dataKey = getKeyFromDom(el),
          downKey = sibling ? getKeyFromDom(sibling) : -1;
        if (downKey == dataKey) {
          downKey = -1;
        }
        let dataIdx = findIndex(
            datas,
            (data, index) => getKeyFromData(data, index) == dataKey
          ),
          downIdx =
            downKey == -1
              ? datas.length
              : findIndex(
                  datas,
                  (data, index) => getKeyFromData(data, index) == downKey
                );
        downIdx = downIdx > dataIdx ? downIdx - 1 : downIdx;
        // tableEdit中拖拽更改第一页之后的数据效果不对的问题
        const { page, pageSize } = this.state;
        if (page && pageSize && page > 1) {
          downIdx = downIdx + (page - 1) * pageSize;
          dataIdx = dataIdx + (page - 1) * pageSize;
        }
        let data = datas.splice(dataIdx, 1)[0];
        datas.splice(downIdx, 0, data);
        // dataIdx:所拖拽的节点的原位置
        // downIdx + 1: 拖拽节点放下来的位置。
        onDrop([...datas], dataIdx, downIdx, data);
      } else {
        isFunction(onDrop) && onDrop(el, sibling, target, source);
      }
    });
  };
}

WeaDragula.propTypes = {
  container: React.PropTypes.any, //可拖拽区域
  canDrag: React.PropTypes.any, //是否可拖拽，可以传方法，方法的传参为当前点击的节点。
  onDrop: React.PropTypes.func, //拖拽结束时触发的方法，第1个参数是拖拽的DOM节点，第二个参数是所放下的位置下方的DOM节点。
  datas: React.PropTypes.array, //数组
  getKeyFromData: React.PropTypes.func, //从数组中获得key的方法。
  getKeyFromDom: React.PropTypes.func //从Dom中获得key的方法
};

const Com = middleware(WeaDragula, "WeaDragula");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-dragula/index.js